import React from "react";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <React.Fragment>
        <section id="map-yellowstone-grand-teton" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Jackson,+WY&daddr=Jenny+Lake,+Grand+Teton+National+Park,+WY+to:Old+Faithful,+Yellowstone+National+Park,+WY+to:Grand+Prismatic+Spring,+Yellowstone,+WY+to:Canyon+Village,+Yellowstone+National+Park,+WY+to:Mammoth+Hot+Springs,+Yellowstone+National+Park,+WY&output=embed"
            width="100%"
            height="420">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}

export default About;
